import {
    Grid, Stack, FormControl, TextField, Typography,
    Button, IconButton, Divider
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import DeleteIcon from '@mui/icons-material/Delete';

import { HOURS_1, HOURS_2 } from '../../../../constants/admin/branch_constants';

const BranchInfo = ({
    values, setValues, inputErr, sharedRefs, inputChange
}) => {
    const { name, phone, email, businessHours } = values;
    const { name_err, phone_err, email_err } = inputErr;
    // referencias a campos
    const { name_ref, phone_ref, email_ref } = sharedRefs;

    const handleInputChange = pos => ({ target: { name, value } }) => {
        const newHours = [...businessHours];

        const key = name === 'dayRange' ? 'rangeError': 'hoursError';
        const hasError = value.length < 5 || value.length > 50;

        newHours[pos] = {
            ...newHours[pos],
            [name]: value,
            [key]: hasError
        };
        setValues(e => ({ ...e, businessHours: newHours }));
    };

    // reestablecer valores iniciales en campo de hora
    const resetHours = pos => () => {
        const newHours = [...businessHours];
        newHours[pos] = {
            ...newHours[pos],
            hours: pos === 0 ? HOURS_1 : HOURS_2
        };
        setValues(e => ({ ...e, businessHours: newHours }));
    };

    const deleteDayRange = (pos) => () => {
        setValues(e => ({
            ...e,
            businessHours: e.businessHours.filter((_, i) => i !== pos)
        }));
    };

    // especificar otro horario de sucursal
    const addDayRange = () => {
        const newHours = [...businessHours];
        newHours.push({
            dayRange: '',
            hours: '',
            error: false
        });
        setValues(e => ({ ...e, businessHours: newHours }));
    };

    return (
        <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={6} sm={12} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        inputProps={{ className: "scroll_input" }}
                        variant='outlined'
                        label='Nombre'
                        size='small'
                        name='name'
                        value={name}
                        error={name_err}
                        // helperText={name_err ? "Ingrese el nombre de la sucursal" : ""}
                        inputRef={name_ref}
                        onChange={inputChange}
                    />
                </FormControl>
            </Grid>
            <Grid item xl={12} lg={12} md={6} sm={12} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        inputProps={{ className: "scroll_input" }}
                        variant='outlined'
                        label='Telefono'
                        size='small'
                        name='phone'
                        value={phone}
                        error={phone_err}
                        helperText={phone_err ? "Ingrese el telefono de la sucursal" : ""}
                        inputRef={phone_ref}
                        onChange={inputChange}
                    />
                </FormControl>
            </Grid>
            <Grid item xl={12} lg={12} md={6} sm={12} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        inputProps={{ className: "scroll_input" }}
                        variant='outlined'
                        label='Correo electrónico'
                        size='small'
                        name='email'
                        value={email}
                        error={email_err}
                        helperText={email_err ? "Ingrese el correo electrónico de la sucursal" : ""}
                        inputRef={email_ref}
                        onChange={inputChange}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Divider textAlign="left" sx={{ fontWeight: '600' }}>Horario</Divider>
                {
                    businessHours.map(({ dayRange, hours, rangeError, hoursError }, i) =>
                        <Stack spacing={2} key={i}>
                            <Stack direction="row" sx={{
                                alignItems: "flex-end",
                            }}>
                                <Typography variant='subtitle2' sx={{ mt: 2 }}>
                                    {`Horario ${i+1}`}
                                </Typography>
                                <IconButton aria-label="delete"
                                    size="small" onClick={deleteDayRange(i)}>
                                    <DeleteIcon fontSize="inherit" />
                                </IconButton>
                            </Stack>
                            
                            <TextField
                                variant='outlined'
                                label='Rango'
                                size='small'
                                name='dayRange'
                                value={dayRange}
                                error={rangeError}
                                helperText={rangeError ? "Ingrese día o rango de apertura" : ""}
                                onChange={handleInputChange(i)}
                            />
                            <Stack direction="row">
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    label='Horas'
                                    size='small'
                                    name='hours'
                                    value={hours}
                                    error={hoursError}
                                    helperText={hoursError ? "Ingrese horario de apertura" : ""}
                                    onChange={handleInputChange(i)}
                                />
                                <IconButton aria-label="limpiar" onClick={resetHours(i)}>
                                    <HistoryIcon />
                                </IconButton>
                            </Stack>
                        </Stack>
                    )
                }
                <Button onClick={addDayRange}>Agregar horario</Button>
            </Grid>
        </Grid>
    );
};

export default BranchInfo;